import React from 'react';
import Big from 'big.js';
import IPurchaseAmount from './IPurchaseAmount';
import IconInput from '@appComponents/IconInput/IconInput';
import CurrencyElement from '@appComponents/CurrencyElement/CurrencyElement';
import Loader from '@appComponents/Loader/Loader';
import { classNames } from '@features/utils/reactFunctions';

import * as style from './PurchaseAmountStyle.module.scss'
import * as elements from '@appStyles/_elements.module.scss';

export const PurchaseAmount: React.FunctionComponent<IPurchaseAmount> = (props) => {
  const big = Big();

  return (
    <>
      {!props.currencyToPay ? <Loader /> : (
        <>
          <div className={style.purchaseAmountInputWrapper}>
            <IconInput
              icon={props.currency}
              onChange={props.handleUpdate}
              value={props.amount || ''}
              errorMsg={props.errors.amount || ''}
              name="amount"
              placeholder="Put Amount here"
              type="text"
              label="Amount of BFT to trade:"
              autoComplete="off"
              data-cy="purchase-input"
            />
            {big(props.amount).lt(props.purchaseWallet.available_purchase_cap!) &&
              <button
                data-cy="maximum-amount-btn"
                className={elements.maximumBtn}
                onClick={props.purchaseAll}
              >
                Maximum Amount
              </button>
            }
          </div>
          <div className={classNames(style.purchaseAmountFlex, style.purchaseAmountFlexOneRow)}>
            <div>
              <p className={style.purchaseAmountMaxLimit}>
                <strong>
                  The maximum limit is&nbsp;
                {props.purchaseWallet &&
                    <CurrencyElement
                      value={
                        props.purchaseWallet!.available_purchase_cap ||
                        0
                      }
                      currency={props.currency}
                    />}
                </strong>
              </p>
            </div>

            <div className={style.details}>
              <p className={style.detailsFee} data-cy="transaction-fee">
                <strong>Transaction Fee: </strong>
                {typeof props.purchaseFees.purchaseFee === 'string'
                  ? props.purchaseFees.purchaseFee
                  : <CurrencyElement
                    value={props.purchaseFees.purchaseFee}
                    currency={props.currencyToPay}
                  />
                }
              </p>
              <p data-cy="total-to-pay">
                <strong>Total to pay: </strong>
                <CurrencyElement
                  value={props.purchaseFees.totalToPay}
                  currency={props.currencyToPay}
                />
              </p>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default React.memo(PurchaseAmount);
